import { DevelopmentPathCycleStateDto } from '@/api/generated';
import { ToStateOptionsDictionariesTranslation } from '@/assets/locales/dictionaries/toStateOptions/toStateOptions.dictionaries.pl.ts';

export const toStateOptionsDictionariesTranslation: ToStateOptionsDictionariesTranslation = {
  [DevelopmentPathCycleStateDto.Archived]: 'Historical',
  [DevelopmentPathCycleStateDto.Cancelled]: 'Cancelled',
  [DevelopmentPathCycleStateDto.Completed]: 'Completed',
  [DevelopmentPathCycleStateDto.Draft]: 'Created draft',
  [DevelopmentPathCycleStateDto.ReadyForRealization]: 'Ready for realization',
  [DevelopmentPathCycleStateDto.SupervisorApproved]: 'Approved by supervisor',
  [DevelopmentPathCycleStateDto.SupervisorRejected]: 'Rejected by supervisor',
};
